/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./authorize-plans.vue?vue&type=template&id=1f7c5e73&"
import script from "./authorize-plans.vue?vue&type=script&lang=js&"
export * from "./authorize-plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports